import React from 'react';
import { Button } from '../ui/button';

const PRHeader = ({ editPR, saving, onCancel, onSave }) => (
  <div className="flex items-center justify-between">
    <div>
      <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Nunito' }}>
        {editPR ? `Edit ${editPR.return_number}` : 'New Purchase Return'}
      </h1>
      <p className="text-gray-500 text-sm">Return goods to vendor — Stock will be deducted</p>
    </div>
    <div className="flex gap-2">
      <Button variant="outline" onClick={onCancel} data-testid="pr-back-btn">Cancel</Button>
      <Button onClick={onSave} disabled={saving} className="bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700" data-testid="pr-save-btn">
        {saving ? 'Saving...' : editPR ? 'Update Return' : 'Create Return'}
      </Button>
    </div>
  </div>
);

export default PRHeader;
